import { Row, Col, Form, message } from 'antd';
import React, { useState } from 'react';
import Init from '../../controls/Init';
import callWebApi from '../../functions/callWebApi';
import TextBox from './../../controls/TextBox';
import DropDownList from './../../controls/DropDownList';
import Button from './../../controls/Button';
//堃
const FormulaRule = ({ iKey, oData, onChange = () => { }, onDelete = () => { }, ...props }) => {
	//{ iRuleID: 3, "iFormulaID": 5, iRoleID: 78, fRangeBegin: 0, fRangeEnd: 4, "iBaseFormulaID", cOperator: "*", fNumeric: 1, iRound: 1 },
	const [aFormula, setFormula] = useState([]);
	//#region 初使化
	Init(() => {
		//#region 下載薪資類型
		callWebApi("/Salary/formula/dataLoad", { aData: {} }, (oResponse) => {
			if (oResponse.bErrOn) { message.error(oResponse.message); return; }
			console.log("oResponse", oResponse);
			setFormula(oResponse.oData.aRows);
		});
		//#endregion
	});
	//#endregion
	const uRangeBegin_OnChange = (fRangeBegin) => {
		onChange(iKey, { ...oData, fRangeBegin: fRangeBegin });
	}
	const uRangeEnd_OnChange = (fRangeEnd) => {
		onChange(iKey, { ...oData, fRangeEnd: fRangeEnd });
	}
	const uBaseFormula_OnChange = (iBaseFormulaID) => {
		onChange(iKey, { ...oData, iBaseFormulaID: iBaseFormulaID });
	}
	const uOperator_OnChange = (cOperator) => {
		onChange(iKey, { ...oData, cOperator: cOperator });
	}
	const uNumeric_OnChange = (fNumeric) => {
		onChange(iKey, { ...oData, fNumeric: fNumeric });
	}
	const uRound_OnChange = (iRound) => {
		onChange(iKey, { ...oData, iRound: iRound });
	}
	const uDelete_OnClick = () => {
		onDelete(iKey, oData);
	}
	return (
		<Row gutter={8}>
			{/* <Col span={3}>
				<Form.Item label="" name={[`FormulaRule_${iKey}`, "fRangeBegin"]} initialValue={oData.fRangeBegin}
					rules={[{ required: true, message: `此為必填項目` }
				]}>
					<TextBox placeholder="超時時數起算" cValue={oData.fRangeBegin} onChange={uRangeBegin_OnChange} />
				</Form.Item>
			</Col>
			<Col span={1}>至</Col>
			<Col span={3}>
				<Form.Item label="" name={[`FormulaRule_${iKey}`, "fRangeEnd"]} initialValue={oData.fRangeEnd}
					rules={[{ required: true, message: `此為必填項目` }
				]}>
					<TextBox placeholder="超時時數截至" cValue={oData.fRangeEnd} style={{Width: "6em"} } onChange={uRangeEnd_OnChange} />
				</Form.Item>
			</Col>
			<Col span={1}>=</Col> */}
			<Col>
				<Form.Item label="" name={[`FormulaRule_${iKey}`, "iBaseFormulaID"]} initialValue={oData.iBaseFormulaID}>
					<DropDownList
						oValue={oData.iBaseFormulaID}
						cFieldValue="iID" cFieldText="cName"
						aOptions={aFormula}
						onChange={value => { uBaseFormula_OnChange(value); }} />
				</Form.Item>
			</Col>
			<Col >
				<Form.Item label="" name={[`FormulaRule_${iKey}`, "cOperator"]} initialValue={oData.cOperator}>
					<DropDownList
						oValue={oData.cOperator}
						cFieldValue="cValue" cFieldText="cText"
						aOptions={[
							{ cValue: "+", cText: "+" }, { cValue: "-", cText: "-" },
							{ cValue: "*", cText: "*" }, { cValue: "/", cText: "/" }
						]}
						onChange={value => { uOperator_OnChange(value); }} />
				</Form.Item>
			</Col>
			<Col>
				<Form.Item label="" name={[`FormulaRule_${iKey}`, "fNumeric"]} initialValue={oData.fNumeric}
					rules={[{ required: true, message: `此為必填項目` }
					]}>
					<TextBox placeholder="倍率" cValue={oData.fNumeric} style={{ Width: "3em" }} onChange={uNumeric_OnChange} />
				</Form.Item>
			</Col>
			{/* <Col >
				<Form.Item label="" name={[`FormulaRule_${iKey}`, "iRound"]} initialValue={oData.iRound}>
					<DropDownList
						oValue={oData.iRound}
						cFieldValue="cValue" cFieldText="cText"
						aOptions={[
							{ cValue: 0, cText: "無條件捨去" }, { cValue: 4, cText: "四捨五入" },
							{ cValue: 1, cText: "無條件進位" }
						]}
						onChange={value => { uRound_OnChange(value); }} />
				</Form.Item>
			</Col> */}
			<Col>
				<Button eType="刪除" onClick={uDelete_OnClick} />
			</Col>
		</Row>
	);
}
export default FormulaRule;
